import React from 'react';
import PropTypes from 'prop-types';

import { Cards, LabelChip } from 'src/components';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { AspectCategoryStatusIcon } from 'src/scenes/Project/scenes/PressuresAndDependencies/components';
import { Add, DragHandle } from '@material-ui/icons';


const useStyles = makeStyles(theme => ({
  icon: {
    fontSize: '12px',
    marginTop: theme.spacing(0.5),
  },
  label: {
    marginRight: theme.spacing(1),
  },
}));

const ImpactList = ({ impacts }) => {
  const classes = useStyles();

  const columns = [
    {
      title: 'Componente',
      width: '5%',
      headerTextAlign: 'center',
      render: ({ componentLabel }) => (
        <Box display="flex" alignItems="center" justifyContent="center">
          <Typography variant="body2" color="textSecondary">{componentLabel}</Typography>
        </Box>
      ),
    },
    {
      title: 'Estado de naturaleza',
      width: '25%',
      headerTextAlign: 'center',
      render: ({ natureStateLabel, natureStateStatus }) => (
        <Box display="flex" alignItems="center" justifyContent="center">
          <Typography className={classes.label} variant="body2" color="textSecondary">
            {natureStateLabel}
          </Typography>
          {/* <Box flexGrow={1} /> */}
          <AspectCategoryStatusIcon category={natureStateStatus} />
        </Box>
      ),
    },
    {
      title: '',
      width: '5%',
      render: () =>
        <Box display="flex" alignItems="center" justifyContent="center">
          <LabelChip label={<Add className={classes.icon} />} variant="outlined" color="default" />
        </Box>,
    },
    {
      title: 'Presión',
      width: '25%',
      headerTextAlign: 'center',
      render: ({ pressureCategoryLabel, pressureCategoryStatus }) => (
        <Box display="flex" alignItems="center" justifyContent="center">
          <Typography className={classes.label} variant="body2" color="textSecondary">
            {pressureCategoryLabel}
          </Typography>
          {/* <Box flexGrow={1} /> */}
          <AspectCategoryStatusIcon category={pressureCategoryStatus} />
        </Box>
      ),
    },
    {
      title: '',
      width: '5%',
      render: () =>
        <Box display="flex" alignItems="center" justifyContent="center">
          <LabelChip label={<DragHandle className={classes.icon} />} variant="outlined" color="default" />
        </Box>,
    },
    {
      title: 'Impacto',
      width: '25%',
      headerTextAlign: 'center',
      render: ({ impactCategoryLabel, impactCategoryStatus }) => (
        <Box display="flex" alignItems="center" justifyContent="center">
          <Typography className={classes.label} variant="body2" color="textSecondary">
            {impactCategoryLabel}
          </Typography>
          {/* <Box flexGrow={1} /> */}
          <AspectCategoryStatusIcon category={impactCategoryStatus} />
        </Box>
      ),
    },
  ];

  return (
    <Cards
      columns={columns}
      values={impacts}
      variant="condensed"
    />
  );
};

ImpactList.propTypes = {
  impacts: PropTypes.array,
};


export { ImpactList };